import { startOfToday } from "date-fns";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone.js";
import utc from "dayjs/plugin/utc.js";
import { normalizeFileDates } from "./normalize-file-dates.mjs";
import { readCsv } from "./read-csv.mjs";
import { HeadCountFileFormat, } from "./types.mjs";
export const segmentTimeObj = {
    S1: "0000-0015",
    S2: "0015-0030",
    S3: "0030-0045",
    S4: "0045-0100",
    S5: "0100-0115",
    S6: "0115-0130",
    S7: "0130-0145",
    S8: "0145-0200",
    S9: "0200-0215",
    S10: "0215-0230",
    S11: "0230-0245",
    S12: "0245-0300",
    S13: "0300-0315",
    S14: "0315-0330",
    S15: "0330-0345",
    S16: "0345-0400",
    S17: "0400-0415",
    S18: "0415-0430",
    S19: "0430-0445",
    S20: "0445-0500",
    S21: "0500-0515",
    S22: "0515-0530",
    S23: "0530-0545",
    S24: "0545-0600",
    S25: "0600-0615",
    S26: "0615-0630",
    S27: "0630-0645",
    S28: "0645-0700",
    S29: "0700-0715",
    S30: "0715-0730",
    S31: "0730-0745",
    S32: "0745-0800",
    S33: "0800-0815",
    S34: "0815-0830",
    S35: "0830-0845",
    S36: "0845-0900",
    S37: "0900-0915",
    S38: "0915-0930",
    S39: "0930-0945",
    S40: "0945-1000",
    S41: "1000-1015",
    S42: "1015-1030",
    S43: "1030-1045",
    S44: "1045-1100",
    S45: "1100-1115",
    S46: "1115-1130",
    S47: "1130-1145",
    S48: "1145-1200",
    S49: "1200-1215",
    S50: "1215-1230",
    S51: "1230-1245",
    S52: "1245-1300",
    S53: "1300-1315",
    S54: "1315-1330",
    S55: "1330-1345",
    S56: "1345-1400",
    S57: "1400-1415",
    S58: "1415-1430",
    S59: "1430-1445",
    S60: "1445-1500",
    S61: "1500-1515",
    S62: "1515-1530",
    S63: "1530-1545",
    S64: "1545-1600",
    S65: "1600-1615",
    S66: "1615-1630",
    S67: "1630-1645",
    S68: "1645-1700",
    S69: "1700-1715",
    S70: "1715-1730",
    S71: "1730-1745",
    S72: "1745-1800",
    S73: "1800-1815",
    S74: "1815-1830",
    S75: "1830-1845",
    S76: "1845-1900",
    S77: "1900-1915",
    S78: "1915-1930",
    S79: "1930-1945",
    S80: "1945-2000",
    S81: "2000-2015",
    S82: "2015-2030",
    S83: "2030-2045",
    S84: "2045-2100",
    S85: "2100-2115",
    S86: "2115-2130",
    S87: "2130-2145",
    S88: "2145-2200",
    S89: "2200-2215",
    S90: "2215-2230",
    S91: "2230-2245",
    S92: "2245-2300",
    S93: "2300-2315",
    S94: "2315-2330",
    S95: "2330-2345",
    S96: "2345-0000",
};
export function getSegment(segmentId) {
    return segmentTimeObj[segmentId];
}
/**
 * Helper function for representing just-a-date™ with a date object, date to
 * represent UTC midnight at the start of the date
 *
 * @param date
 */
export function deserializeDate(date) {
    const parsedDate = new Date(date);
    return new Date(Date.UTC(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate()));
}
export function filterBetweenDates(transformedData, startPlanningAt, endPlanningAt) {
    const start = deserializeDate(startPlanningAt);
    const end = deserializeDate(endPlanningAt);
    return transformedData.filter((line) => {
        const effective = deserializeDate(line.effectiveDate);
        return effective >= start && effective <= end;
    });
}
export const SEGMENTS = Object.values(segmentTimeObj);
/**
 * Receives a job as a string. Returns the location part.
 * Assume that if the job string is to short (business logic short).
 * Then return all the elements as the location.
 *
 * @param job - the job as a slash-delimited string
 * @return json object with location with key qualifier
 */
export function getLocation(job) {
    const location = job.split("/");
    const length = location.length > 7 ? location.length - 1 : 7;
    return location.slice(0, length).join("/");
}
/**
 * Detect whether your file is Behovsverktyg, CFF, or Invision, or undefined.
 */
export function detectFileFormat(content) {
    if (/(Department Path,Effective Date,Job Path)(,S\d){9}(,S\d\d){87}/g.test(content)) {
        return HeadCountFileFormat.CFF;
    }
    if (/(Datum;Dag;Typdag;Mönster;Styrka;TS)(;\d\d:\d\d){96}(;;;Aktivitet)/g.test(content)) {
        return HeadCountFileFormat.BEHOVSVERKTYG;
    }
    if (/Planeringsenhet/g.test(content)) {
        return HeadCountFileFormat.INVISION;
    }
    if (/Date(;\d\d:\d\d){96}/g.test(content)) {
        return HeadCountFileFormat.TEMPLATE;
    }
    if (/Date[;,][Aa]ctivity([;,]\d\d:\d\d){96}/g.test(content)) {
        return HeadCountFileFormat.TEMPLATE_ACTIVITY;
    }
    // This code is for detecting the MST Switzerland file format by header
    // It's done in JavaScript to avoid complex regex
    const headers = content.split(/\r?\n/, 1);
    if (headers[0] !== undefined) {
        const headerArray = headers[0].split(";");
        const timesInHeader = headerArray.slice(3);
        const expectedTimes = Array.from({ length: 96 }, (_, i) => `${String(Math.floor(i / 4)).padStart(2, "0")}:${String((i % 4) * 15).padStart(2, "0")}`);
        const isValidMst = expectedTimes.every((time, index) => time === timesInHeader[index]);
        // This has to be last since it matches the content of the file rather than the headers
        if (isValidMst) {
            return HeadCountFileFormat.MST_SWITZERLAND;
        }
    }
    throw new Error("File not recognized");
}
export const defaultEndTime = ["00", "00"];
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * Create a property name based on either
 * fieldName or count if fieldName is empty.
 *
 * @param fieldName - The name of the field
 * @param count -  current count
 * @return the name of the property.
 */
function setPropertyName(fieldName, count) {
    return fieldName === '""' || fieldName === "" ? `__${count}` : fieldName;
}
/**
 * Convert the array of time into qualifiers.
 * A qualifier is based on this value and next value.
 * If no next value default is to set midnight.
 *
 * @param headers - the header line
 * @param timeArray - the array of the times to convert.
 * @param startTimeArray - from which column to start building the qualifies from.
 * @param offset - offSet from end to stop
 * @return
 */
export function convertTimeToQualifiers(headers, timeArray, startTimeArray, offset) {
    const qualifiers = {};
    const maxSearch = headers.length - offset;
    for (let j = 0; j < maxSearch; j += 1) {
        const propertyName = setPropertyName(headers[j], j);
        let qualifier = timeArray[j];
        if (j >= startTimeArray) {
            const value = qualifier.split(":");
            let nextValue = defaultEndTime;
            const k = j + 1;
            if (timeArray[k] !== undefined && k < maxSearch) {
                nextValue = timeArray[k].split(":");
            }
            qualifier = `${value.join("")}-${nextValue.join("")}`;
        }
        qualifiers[propertyName] = qualifier;
    }
    return qualifiers;
}
/**
 * Convert the array of time into qualifiers.
 * A qualifier is based on this value and next value.
 * If no next value default is to set midnight.
 *
 * @param headers - the header line
 * @param segmentArray - the array of the times to convert.
 * @param startSegmentArray - from which column to start builing the qualifies from.
 * @param offset - offSet from end to stop
 * @return
 */
export function convertSegmentToQualifiers(headers, segmentArray, startSegmentArray, offset) {
    const qualifiers = {};
    const maxSearch = headers.length - offset;
    for (let j = 0; j < maxSearch; j += 1) {
        const propertyName = setPropertyName(headers[j], j);
        let qualifier = segmentArray[j];
        if (j >= startSegmentArray) {
            qualifier = getSegment(segmentArray[j]);
        }
        qualifiers[propertyName] = qualifier;
    }
    return qualifiers;
}
/**
 * Takes a date string in two different formats and converse to a dayjs object.
 *
 * @param date - the date as string
 * @return a dayjs object based on the date param
 */
export function formatDate(date) {
    let dateString = String(date);
    let dateObj = dayjs();
    if (dateString.match(/^(\S{2})\s(\d+)\s(\S{3}.)$/g) != null) {
        dateString = dateString
            .replace(".", "")
            .substring(3)
            .replace("Okt", "Oct")
            .replace("Maj", "Mai")
            .trim();
        dateObj = dayjs(dateString, "DD MMM");
        const currentYear = dayjs().year();
        if (dateObj.year() < currentYear) {
            dateObj = dateObj.year(currentYear);
        }
        if (dateObj < dayjs()) {
            dateObj = dateObj.add(1, "year");
        }
    }
    else {
        dateObj = dayjs(dateString);
    }
    return dateObj;
}
/**
 * Take a date and extract the day of the week. Returned in uppercase.
 *
 * @param date - dayjs object
 * @return the day of the week from the date object
 */
function getDayOfWeek(date) {
    return date.format("dddd").toUpperCase();
}
function buildJsonResult(headers, currentLine, qualifiers, startWorkloadColumn, job) {
    const workload = [];
    const date = formatDate(currentLine[0]);
    const dayOfWeek = getDayOfWeek(date);
    for (let j = startWorkloadColumn; j < headers.length; j += 1) {
        workload.push({
            count: currentLine[j],
            scheduleZone: qualifiers[setPropertyName(headers[j], j)],
            dayOfWeek,
        });
    }
    return {
        job: job,
        location: getLocation(job),
        effectiveDate: date.format("YYYY-MM-DD"),
        expirationDate: date.add(5, "year").format("YYYY-MM-DD"),
        workload,
    };
}
const buildJsonResultWithPattern = (headers, currentLine, qualifiers, pattern, maybeJob) => {
    const workload = [];
    const maxSearch = headers.length - pattern.offset;
    const date = formatDate(currentLine[pattern.effectiveDatePos]);
    const dayOfWeek = getDayOfWeek(date);
    for (let j = pattern.startWorkloadColumn; j < maxSearch; j += 1) {
        workload.push({
            count: currentLine[j],
            scheduleZone: qualifiers[setPropertyName(headers[j], j)],
            dayOfWeek,
        });
    }
    const job = maybeJob || currentLine[pattern.jobPos];
    return {
        job,
        location: getLocation(job),
        effectiveDate: date.format("YYYY-MM-DD"),
        expirationDate: date.add(5, "year").format("YYYY-MM-DD"),
        workload,
    };
};
/**
 * Transpose the invision csv from column to rows.
 * Map the transposed data into a json structure which is easy to convert to the api-payload.
 * Headers on row 0.
 * Time values on row 1.
 * Actual data is on row 4 and onwards.
 */
export function convertInvisionFile(data, job) {
    const startTimeArray = 1;
    const startDataRow = 4;
    const startWorkloadColumn = 3;
    const lines = readCsv(data);
    // Remove all lines that are in raw file and do not contain relevant workload data
    const filteredLines = lines.filter((x) => x[0] === "" && x[1].length > 0);
    // Transpose for parsing
    const transposedLines = filteredLines[0].map((_, col) => filteredLines.map((row) => row[col]));
    const headers = transposedLines[0];
    const qualifiers = convertTimeToQualifiers(headers, transposedLines[1], startTimeArray, 0);
    const jsonResult = [];
    for (let i = startDataRow; i < transposedLines.length; i++) {
        // Skip rows that don't contain value in each column, not containing workload data
        const line = transposedLines[i];
        if (line.filter((x) => x.length).length === line.length) {
            const jsonObject = buildJsonResult(headers, line, qualifiers, startWorkloadColumn, job);
            if (jsonObject.workload[0]?.count !== undefined) {
                // Fill missing segments for the day with 0 workload requirement
                const segmentsInWorkload = jsonObject.workload.map((x) => x.scheduleZone);
                const missingSegments = SEGMENTS.filter((x) => !segmentsInWorkload.includes(x));
                missingSegments.forEach((missing) => {
                    jsonObject.workload.push({
                        count: "0",
                        scheduleZone: missing,
                        dayOfWeek: jsonObject.workload[0].dayOfWeek,
                    });
                });
                jsonResult.push(jsonObject);
            }
        }
    }
    return jsonResult;
}
/**
 * Transpose a linear csv to json
 * A linear csv is easy to parse, without any odd rows that need be excluded or missing columns
 * Linear csv are: "Behovsverktyget", "CFF" and "Template"
 */
function convertLinearFile(data, job, startTimeArray, startDataRow, pattern, offset = 0) {
    const lines = readCsv(data);
    const headers = lines[0];
    const getQualifiersFn = headers.some(getSegment)
        ? convertSegmentToQualifiers
        : convertTimeToQualifiers;
    const qualifiers = getQualifiersFn(headers, headers, startTimeArray, offset);
    const jsonResult = [];
    for (let i = startDataRow; i < lines.length; i += 1) {
        const jsonObject = buildJsonResultWithPattern(headers, lines[i], qualifiers, pattern, job);
        if (jsonObject.workload[0].count !== undefined) {
            jsonResult.push(jsonObject);
        }
    }
    return jsonResult;
}
/**
 * Transpose the Behovsverktyget csv to json
 */
export function convertBVFile(data, job) {
    return convertLinearFile(data, job, 6, 1, {
        effectiveDatePos: 0,
        startWorkloadColumn: 6,
        offset: 3,
    }, 3);
}
/**
 * Transpose the Behovsverktyg Activity csv to json
 */
export function convertMstSwitzerland(data) {
    return convertLinearFile(data, null, // null indicates job path is inside of file
    3, // This is the index of the column where the workload starts
    1, // This is the index of the row where the workload starts
    {
        effectiveDatePos: 0,
        startWorkloadColumn: 3,
        offset: 0,
        jobPos: 1,
    }, 0);
}
/**
 * Transpose the Behovsverktyg Activity csv to json
 */
export function convertBVCompact(data, job) {
    return convertLinearFile(data, job, 3, // This is the index of the column where the workload starts
    1, // This is the index of the row where the workload starts
    {
        effectiveDatePos: 0,
        startWorkloadColumn: 3,
        offset: 0,
        jobPos: 2,
    }, 0);
}
/**
 * Transpose the Behovsverktyg Activity csv to json
 */
export function convertBVActivityFile(data, job) {
    return convertLinearFile(data, job, 6, 1, {
        effectiveDatePos: 0,
        startWorkloadColumn: 6,
        offset: 3,
        jobPos: 2,
    }, 3);
}
/**
 * Transpose the CFF csv to json
 */
export function convertCFFFile(data) {
    return convertLinearFile(data, null, 3, 1, {
        effectiveDatePos: 1,
        startWorkloadColumn: 3,
        offset: 0,
        jobPos: 2,
    }, 0);
}
/**
 * Transpose the Template csv to json
 */
export function convertTemplateFile(data, job) {
    return convertLinearFile(data, job, 1, 1, {
        effectiveDatePos: 0,
        startWorkloadColumn: 1,
        offset: 0,
    }, 0);
}
/**
 * Transpose the Template csv to json
 */
export function convertTemplateActivtyFile(data) {
    return convertLinearFile(data, null, // null indicates job path is inside of file
    2, // This is the index of the COLUMN where the workload starts
    1, // This is the index of the ROW where the workload starts
    {
        effectiveDatePos: 0,
        startWorkloadColumn: 2,
        offset: 0,
        jobPos: 1,
    }, 0);
}
/**
 * First try as CFF file, then BV and last assume it's a invision file.
 * Converter for CFF and BV has headers and a matching regexp to check.
 * Converter returns null if the headers don't match.
 *
 * @param data - the csv file data
 * @param job - job path for file
 * @param planType
 * @param format - type of file
 * @return a json object
 */
export const transposeAndToJson = (data, job, format) => {
    // TODO: job type should depend on format
    switch (format) {
        case HeadCountFileFormat.CFF:
            return convertCFFFile(data);
        case HeadCountFileFormat.BEHOVSVERKTYG:
            return convertBVFile(data, job);
        case HeadCountFileFormat.INVISION:
            return convertInvisionFile(data, job);
        case HeadCountFileFormat.TEMPLATE:
            return convertTemplateFile(data, job);
        case HeadCountFileFormat.TEMPLATE_ACTIVITY:
            return convertTemplateActivtyFile(data);
        case HeadCountFileFormat.MST_SWITZERLAND:
            return convertMstSwitzerland(data);
        default:
            throw Error(`Unknown format ${format}`);
    }
};
export const transformDataV2 = (file) => (data) => {
    const start = file.startPlanningAt;
    const end = file.endPlanningAt;
    const transposed = transposeAndToJson(data, file.job, file.format);
    const raw = start && end ? filterBetweenDates(transposed, start, end) : transposed;
    if (raw.length === 0) {
        throw Error("No data in file or in selected period");
    }
    const output = raw.map((item) => {
        return {
            date: item.effectiveDate,
            orgActivityId: item.job,
            value: item.workload.map((w) => Number.parseInt(w.count)),
            planType: [file.planType],
        };
    });
    return output;
};
function findMinMaxDates(data) {
    const firstRow = data[0];
    if (firstRow === undefined) {
        throw new Error("No data in file or in selected period");
    }
    const today = startOfToday();
    let hasFutureDates = false;
    const initialDate = new Date(firstRow.date);
    const { minDate, maxDate } = data.reduce((result, row) => {
        const currentDate = new Date(row.date);
        if (currentDate >= today) {
            hasFutureDates = true;
        }
        return {
            minDate: currentDate < result.minDate ? currentDate : result.minDate,
            maxDate: currentDate > result.maxDate ? currentDate : result.maxDate,
        };
    }, {
        minDate: initialDate,
        maxDate: initialDate,
    });
    return { minDate, maxDate, hasFutureDates };
}
/**
 * Finds the minimum and maximum dates from the given file content and metadata.
 */
export function fetchMinMaxDates(data, file) {
    data = normalizeFileDates(data, file.format);
    const transformedData = transformDataV2(file)(data);
    return findMinMaxDates(transformedData);
}
/**
 * The Function is meant to create a summary of yet not uploaded/processed files that
 * are always containing activity defined as a job path.
 * When parsing the job path following order of Business Structure is assumed:
 */
export const getSummary = (filename, data) => {
    const daysChanged = new Set();
    const activitiesChanged = new Set();
    const period = {
        minDate: "",
        maxDate: "",
    };
    data.forEach((item) => {
        daysChanged.add(item.date);
        activitiesChanged.add(item.orgActivityId);
        if (!period.minDate || item.date < period.minDate) {
            period.minDate = item.date;
        }
        if (!period.maxDate || item.date > period.maxDate) {
            period.maxDate = item.date;
        }
    });
    return [
        {
            files: [
                {
                    file: filename,
                    daysChanged: daysChanged.size,
                    activities: [...activitiesChanged],
                    startPeriod: period.minDate,
                    endPeriod: period.maxDate,
                },
            ],
        },
    ];
};
/**
 * Calculates the shortest window for the planning method. Takes these dates/ranges in to consideration: valid period for the method,
 * the planning period the user selects and if it's today or before today.
 */
export function getPlanningMethodWindow(methodValidPeriod, planningPeriod) {
    const today = new Date();
    const m = methodValidPeriod;
    const p = planningPeriod;
    const min = p[0] > m[0] ? p[0] : m[0];
    const max = p[1] < m[1] ? p[1] : m[1];
    if (today < min) {
        return [min, max];
    }
    return [today, max];
}
//# sourceMappingURL=data-transformations.mjs.map